import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import { authApi } from '../../api/auth';
import { extractErrorMessage } from '../../api/errors';
import Button from '../../components/ui/Button';
import PasswordInput from '../../components/ui/PasswordInput';
import AuthShell from './AuthShell';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const uid = params.get('uid') || '';
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const missingLink = !uid || !token;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) {
      setError("Passwords don't match.");
      return;
    }
    setSubmitting(true);
    try {
      await authApi.confirmPasswordReset({ uid, token, new_password: password });
      setDone(true);
    } catch (err) {
      setError(extractErrorMessage(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthShell
      title={done ? 'Password updated' : 'Reset password'}
      subtitle={
        done
          ? 'Sign in with your new password.'
          : missingLink
            ? 'This reset link is missing required parameters.'
            : 'Pick a new password. Eight characters or more.'
      }
      footer={
        <Link to="/login" className="font-medium text-green-700 hover:text-green-800">
          Back to sign in
        </Link>
      }
    >
      {!done && !missingLink && (
        <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
          <PasswordInput
            label="New password"
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={8}
          />
          <PasswordInput
            label="Confirm new password"
            autoComplete="new-password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
            minLength={8}
          />
          {error && <p className="text-sm text-red-600">{error}</p>}
          <Button type="submit" disabled={submitting}>
            {submitting ? 'Updating…' : 'Update password'}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
